import React from 'react';
import { motion, isValidMotionProp } from 'framer-motion';
import { forwardRef, chakra } from '@chakra-ui/react';

const MotionBox = motion(
  forwardRef((props, ref) => {
    const chakraProps = Object.entries(props)
      .filter(([key]) => !isValidMotionProp(key))
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    return <chakra.div ref={ref} {...chakraProps} />;
  }),
);

export default MotionBox;
